import { render, staticRenderFns } from "./RotuloSeplag.vue?vue&type=template&id=e64a3cb4&scoped=true&"
import script from "./RotuloSeplag.vue?vue&type=script&lang=js&"
export * from "./RotuloSeplag.vue?vue&type=script&lang=js&"
import style0 from "./RotuloSeplag.vue?vue&type=style&index=0&id=e64a3cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a3cb4",
  null
  
)

export default component.exports